import axios from 'axios';
import change from 'redux-form';
import { browserHistory } from 'react-router';

import {
  REQUEST_VENDORS,
  FETCH_VENDORS_SUCCESS,
  FETCH_VENDORS_FAILURE,
  SELECT_VENDOR,
  RESET_CURRENT_VENDOR,
  REQUEST_CREATING_VENDOR,
  CREATE_VENDOR_SUCCESS,
  CREATE_VENDOR_FAILURE,
  REQUEST_EDITING_VENDOR,
  EDIT_VENDOR_SUCCESS,
  EDIT_VENDOR_FAILURE,
  REQUEST_VENDOR_DETAIL,
  FETCH_VENDOR_DETAIL_SUCCESS,
  FETCH_VENDOR_DETAIL_FAILURE,
  REQUEST_VENDOR_INVENTORY_DETAIL,
  FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
  FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
  REQUEST_VENDOR_RECORDS,
  FETCH_VENDOR_RECORDS_SUCCESS,
  FETCH_VENDOR_RECORDS_FAILURE,
  FETCH_VENDOR_BATCHES,
  FETCH_VENDOR_BATCHES_SUCCESS,
  FETCH_VENDOR_BATCHES_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
} from './type'

import {
  VENDOR_URL,
  VENDOR_INVENTORY_URL,
  OUTSTANDING_VENDOR_URL,
  UPLOAD_URL,
} from './url'

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchVendors() {
  return dispatch => {
    dispatch(requestVendors());
    return axios.get(VENDOR_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(fetchVendorsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchVendorsFailure(err));
      });
  }
}

export function fetchActiveVendors() {
  return dispatch => {
    dispatch(requestVendors());
    return axios({
      method: 'get',
      url: `${VENDOR_URL}?Vendor_id__IsActive=1`,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    }).then(response => {
      dispatch(fetchVendorsSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchVendorsFailure(err));
    });
  }
}

export function requestVendors() {
  return {
    type: REQUEST_VENDORS,
  };
}

export function fetchVendorsSuccess(vendors) {
  return {
    type: FETCH_VENDORS_SUCCESS,
    payload: vendors
  };
}

export function fetchVendorsFailure(error) {
  return {
    type: FETCH_VENDORS_FAILURE,
    payload: error
  };
}

export function selectVendor(vendor) {
  return {
    type: SELECT_VENDOR,
    payload: vendor
  };
}

export function resetCurrentVendor() {
  return {
    type: RESET_CURRENT_VENDOR
  }
}


// Actions to deal with the promise of posting function.

export function createVendor({
  VendorNum,
  RefNum,
  Phone,
  Name,
  Description,
  CreditStatus,
  IsActive,
  Purchaser_User_id,
  PaymentTerm_id,
  default_purchaser_user_id,
  Shipping,
  Mailing,
  Billing,
}) {
  if(PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if(default_purchaser_user_id){
    default_purchaser_user_id = default_purchaser_user_id.value || default_purchaser_user_id
  }
  return dispatch => {
    dispatch({ type: REQUEST_CREATING_VENDOR });
    axios.post(VENDOR_URL,
      {
        VendorNum,
        RefNum,
        Phone,
        Name,
        Description,
        CreditStatus,
        IsActive,
        Purchaser_User_id,
        PaymentTerm_id,
        default_purchaser_user_id,
        Shipping,
        Mailing,
        Billing,
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(createVendorSuccess());
      browserHistory.push('/vendors');
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(createVendorFailure(err));
    });
  }
}

export function requestCreatingVendor() {
  return {
    type: REQUEST_CREATING_VENDOR
  }
}

export function createVendorSuccess() {
  return {
    type: CREATE_VENDOR_SUCCESS
  }
}

export function createVendorFailure(error) {
  return {
    type: CREATE_VENDOR_FAILURE,
    payload: error
  }
}

export function editVendor({
  Vendor_id,
  VendorNum,
  RefNum,
  Phone,
  Name,
  Description,
  CreditStatus,
  IsActive,
  Purchaser_User_id,
  PaymentTerm_id,
  default_purchaser_user_id,
  Shipping,
  Mailing,
  Billing,
}) {
  if (PaymentTerm_id) {
    PaymentTerm_id = PaymentTerm_id.value || PaymentTerm_id;
  }
  if(default_purchaser_user_id){
    default_purchaser_user_id = default_purchaser_user_id.value || default_purchaser_user_id
  }
  return dispatch => {
    dispatch({ type: REQUEST_EDITING_VENDOR });
    axios.put((VENDOR_URL + Vendor_id),
      {
        VendorNum,
        RefNum,
        Phone,
        Name,
        Description,
        CreditStatus,
        IsActive,
        Purchaser_User_id,
        PaymentTerm_id,
        default_purchaser_user_id,
        Shipping,
        Mailing,
        Billing,
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(editVendorSuccess());
      browserHistory.push('/vendors'); // If editd succesfully, refresh the paymentTerm page.
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(editVendorFailure(err));
    });
  }
}

export function requestEditingVendor() {
  return {
    type: REQUEST_EDITING_VENDOR
  }
}

export function editVendorSuccess() {
  return {
    type: EDIT_VENDOR_SUCCESS
  }
}

export function editVendorFailure(error) {
  return {
    type: EDIT_VENDOR_FAILURE,
    payload: error
  }
}

// Fetch the detail page.
export function fetchVendorDetail(vendor_id) {
  return dispatch => {
    dispatch(requestVendorDetail());
    return axios.get(VENDOR_URL + vendor_id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorDetailSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchVendorDetailFailure(err));
    });
  }
}

export function requestVendorDetail() {
  return {
    type: REQUEST_VENDOR_DETAIL,
  };
}

export function fetchVendorDetailSuccess(vendorDetail) {
  return {
    type: FETCH_VENDOR_DETAIL_SUCCESS,
    payload: vendorDetail
  };
}

export function fetchVendorDetailFailure(error) {
  return {
    type: FETCH_VENDOR_DETAIL_FAILURE,
    payload: error
  };
}

export function fetchVendorInventoryDetail(vendor_id) {
  return dispatch => {
    dispatch(requestVendorInventoryDetail());
    return axios.get(VENDOR_INVENTORY_URL + vendor_id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorInventoryDetailSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchVendorInventoryDetailFailure(err));
    });
  }
}

export function requestVendorInventoryDetail() {
  return {
    type: REQUEST_VENDOR_INVENTORY_DETAIL,
  };
}

export function fetchVendorInventoryDetailSuccess(vendorDetail) {
  return {
    type: FETCH_VENDOR_INVENTORY_DETAIL_SUCCESS,
    payload: vendorDetail
  };
}

export function fetchVendorInventoryDetailFailure(error) {
  return {
    type: FETCH_VENDOR_INVENTORY_DETAIL_FAILURE,
    payload: error
  };
}

export function fetchVendorRecords() {
  return dispatch => {
    dispatch(requestVendorRecords());
    return axios.get(OUTSTANDING_VENDOR_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(fetchVendorRecordsSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchVendorRecordsFailure(err));
    });
  }
}

export function requestVendorRecords() {
  return {
    type: REQUEST_VENDOR_RECORDS
  }
}

export function fetchVendorRecordsSuccess(records) {
  return {
    type: FETCH_VENDOR_RECORDS_SUCCESS,
    payload: records
  }
}

export function fetchVendorRecordsFailure(error) {
  return {
    type: FETCH_VENDOR_RECORDS_FAILURE,
    payload: error
  }
}

export function getVendorBatches(vendor_id) {
  return dispatch => {
    dispatch({type: FETCH_VENDOR_BATCHES});
    return axios.get(VENDOR_INVENTORY_URL+vendor_id,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
    .then(response => {
      dispatch(getVendorBatchesSuccess(response));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(getVendorBatchesFailure(err));
    });
  }
}

function getVendorBatchesSuccess(data) {
  return {
    type: FETCH_VENDOR_BATCHES_SUCCESS,
    payload: data
  }
}

function getVendorBatchesFailure(error) {
  return {
    type: FETCH_VENDOR_BATCHES_FAILURE,
    payload: error
  }
}

export function attachDocument(files) {
  return dispatch => {
    dispatch({type: ATTACH_DOCUMENT});
    var data = new FormData();
    data.append('vendor_file', files[0]);
    //UPLOAD_URL + 'vendor/' <--- old api
    return axios.post(
      `${VENDOR_URL}import/`,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      
      })
      .then(response => {
        dispatch(attachDocumentSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(attachDocumentFailure(err));
      });
  }
}

export function attachDocumentSuccess() {
  return {
    type: ATTACH_DOCUMENT_SUCCESS,
  };
}

export function attachDocumentFailure(error) {
  return {
    type: ATTACH_DOCUMENT_FAILURE,
    payload: error
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/vendors_actions.js